function injectStyle (ssrContext) {
  require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-b2ea7324\",\"scoped\":true,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector?type=styles&index=0!./VueBootstrapTypeahead.vue")
}
var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./VueBootstrapTypeahead.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b2ea7324\"}!../../../vue-loader/lib/selector?type=template&index=0!./VueBootstrapTypeahead.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b2ea7324",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-bootstrap-typeahead/src/components/VueBootstrapTypeahead.vue
// module id = 1097
// module chunks = 5